import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Pagination, Table } from '@mantine/core';
import CustomerTransactionListItem from './CustomerTransactionListItem';
import AppStack from '../../common/AppStack';
import AppFlexbox from '../../common/AppFlexbox';
import AppText from '../../common/AppText';

const MAX_PAGE_LENGTH = 5;

const CustomerTransactionList = ({ isLoading, payments = [] }) => {
  const [pageIndex, setPageIndex] = useState(1);

  return (
    <AppStack style={{ gap: 10 }}>
      <AppFlexbox style={{ flex: 1, justifyContent: 'space-between' }}>
        <AppText weight={500}>Transaction Log</AppText>
      </AppFlexbox>

      <AppStack>
        <AppStack style={{ overflow: 'auto', flex: 1, gap: 0 }}>
          <Table
            horizontalSpacing="md"
            style={{ border: 'solid 1px #ced4da' }}
            verticalSpacing="md"
          >
            <Table.Thead>
              <Table.Tr>
                <Table.Th>
                  <AppText style={{ whiteSpace: 'nowrap' }}>Status</AppText>
                </Table.Th>
                <Table.Th>
                  <AppText style={{ whiteSpace: 'nowrap' }}>Date</AppText>
                </Table.Th>
                <Table.Th>
                  <AppText style={{ whiteSpace: 'nowrap' }}>Type</AppText>
                </Table.Th>
                <Table.Th>
                  <AppText style={{ whiteSpace: 'nowrap' }}>Method</AppText>
                </Table.Th>
                <Table.Th>
                  <AppText style={{ whiteSpace: 'nowrap', textAlign: 'end' }}>
                    Amount
                  </AppText>
                </Table.Th>
              </Table.Tr>
            </Table.Thead>

            <Table.Tbody>
              {isLoading ? (
                <>
                  <CustomerTransactionListItem />
                  <CustomerTransactionListItem />
                </>
              ) : payments.length === 0 ? (
                <Table.Tr>
                  <Table.Td
                    colSpan={5}
                    style={{ padding: 50, textAlign: 'center' }}
                  >
                    <AppText weight={500}>- No Payments Received -</AppText>
                  </Table.Td>
                </Table.Tr>
              ) : (
                [...payments]
                  .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                  .slice(
                    -MAX_PAGE_LENGTH + pageIndex * MAX_PAGE_LENGTH,
                    pageIndex * MAX_PAGE_LENGTH
                  )
                  .map((p) => (
                    <CustomerTransactionListItem
                      key={p.pkRegFormSubmissionPayment}
                      regFormSubmissionPayment={p}
                    />
                  ))
              )}
            </Table.Tbody>
          </Table>
        </AppStack>

        {!isLoading && payments.length > MAX_PAGE_LENGTH && (
          <AppFlexbox style={{ justifyContent: 'center' }}>
            <Pagination
              color="blue"
              onChange={setPageIndex}
              total={Math.ceil(payments.length / MAX_PAGE_LENGTH)}
              value={pageIndex}
            />
          </AppFlexbox>
        )}
      </AppStack>
    </AppStack>
  );
};

CustomerTransactionList.propTypes = {
  isLoading: PropTypes.bool,
  payments: PropTypes.array
};

export default CustomerTransactionList;
